import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import avatar from '../../assest/avatar-1.jpg'
import { FaAngleDown, FaBars } from 'react-icons/fa6'
import logo from '../../assest/ghumlog.jpeg'
import { useDispatch } from 'react-redux'
import { logout } from '../../../redux/reducer/reducer'
import { FaLock } from 'react-icons/fa'
import { IoLogOut } from "react-icons/io5";
const Header = ({handleToggle, setShowPass}) => {
const [showDropdown, setShowDropdown] = useState(false)
const dispatch = useDispatch()
const handleLogout = () => {
    dispatch(logout())
}
  return (
    <>
    <header className='admin-header p-4 bg-white d-flex justify-content-between  align-items-center  '>
        <div className='d-flex  align-items-center '>
        <Link className="admin-toggler me-3 fs-2 text-black" onClick={handleToggle}><FaBars/></Link>
        <img src={logo} alt="Ghumne Jao" width={200} />
        </div>
        <div className='position-relative'>
            <img src={avatar} alt="" width={40} className=' rounded-5 me-2' />
            <Link className=' text-dark-emphasis ' onClick={() => setShowDropdown(!showDropdown)}>
            Admin 
            <FaAngleDown/>
            </Link>
            {
                showDropdown && (
            <div className="admin-dropdown-menu position-absolute  end-0  top-100 bg-white pt-3 ps-3 rounded-1 z-1  ">
                <span className='text-dark-emphasis wel fw-medium '>Welcome!</span>
                <ul className=' pb-2 px-4'>
                    <li className='my-3 text-dark-emphasis list-unstyled'><Link onClick={() => setShowPass(true)} className='text-dark-emphasis'><FaLock/> Change Password</Link></li>
                    <li className='my-3 text-dark-emphasis list-unstyled'><Link onClick={handleLogout} className='text-dark-emphasis'><IoLogOut /> Logout</Link></li>
                </ul>
            </div>
                     
                     )
                    }
        </div>
    </header>
    </>
  )
}

export default Header